import { stringValidator } from '#validation/common/validators';
import { GUEST_LINKS_NAME_MAX_LENGTH, GUEST_LINKS_NAME_MIN_LENGTH, } from '../constants';
export const guestLinkNameValidator = stringValidator({
    minLength: {
        min: GUEST_LINKS_NAME_MIN_LENGTH,
        error: 'guestLink.name.minLength',
    },
    maxLength: {
        max: GUEST_LINKS_NAME_MAX_LENGTH,
        error: 'guestLink.name.maxLength',
    },
});
